import React, { useEffect, useState } from 'react'
import HeaderTitle from '../../../components/HeaderTitle'
import BackButton from '../../../components/BackButton'
import axios from 'axios'
import { useSelector } from 'react-redux'
import swal from 'sweetalert'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import ControlPage from '../../Auth/ControlPage'
import { isAdmin } from '../../../utils/roleUtils'

function CreateUser() {
    const form = useForm()
    const navigate = useNavigate()
    const { token, role } = useSelector((state) => state.auth)

    const [roles, setRoles] = useState([])
    const [companies, setCompanies] = useState([])

    const getRoles = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/role`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                setRoles(response.data)
            })
            .catch((error) => {
                console.error(error)
                setRoles([])
                swal('Roller getirilirken hata oluştu', {
                    icon: 'error'
                })

            })
    }

    const getCompanies = (companyType) => {
        console.log(companyType)
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/company?roleIndex=${companyType}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                setCompanies(response.data)
            })
            .catch((error) => {
                console.error(error)
                setCompanies([])
                swal('Şirketler getirilirken hata oluştu', {
                    icon: 'error'
                })
            })

    }

    const saveUser = (data) => {
        console.log(data)

        if(data.company === "100") {
            data.company = null
        }

        axios.post(`${process.env.REACT_APP_SERVICE_URL}/user`, {
            username: data.username,
            password: data.password,
            firstName: data.firstName,
            lastName: data.lastName,
            phoneNumber: data.phoneNumber,
            roles: [data.roles],
            company: data.company
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                form.reset()
                swal('Kullanıcı başarıyla oluşturuldu', {
                    icon: 'success'
                })
                navigate(-1)
            })
            .catch((error) => {
                console.error(error)
                swal('Kullanıcı oluşturulurken hata oluştu', {
                    icon: 'error'
                })
            })
    }

    useEffect(() => {
        getRoles()
    }, [])

    if (!isAdmin(role)) {
        return (
            <ControlPage />
        );
    }

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Kullanıcı Ekle</title>
                <meta name='description' content='Sistemde yeni bir kullanıcı oluşturun' />
                <meta name='viewport' content='width=device-width, initial-scale=1, shrink-to-fit=no' />
            </Helmet>
            <HeaderTitle title='Kullanıcı Ekle' description='Sistemde yeni bir kullanıcı oluşturun' />

            <div className='row'>
                <div className='col-md-4'>
                    <div className='card'>
                        <div className='card-body'>
                            <BackButton />
                            <form className='mt-3' onSubmit={form.handleSubmit(saveUser)}>
                                <div className='mb-3'>
                                    <label htmlFor='role' className='form-label'>Rol</label>
                                    <select
                                        {...form.register('roles')}
                                        className='form-select'
                                        id='role'
                                        onChange={(e) => getCompanies(e.target.value)}
                                    >
                                        <option>Seçin</option>
                                        {
                                            roles?.map((role) => (
                                                <option key={role.id} value={role.id}>{role.name}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div className='mb-3 row'>
                                    <div className='col'>
                                        <label htmlFor='name' className='form-label'>Adı</label>
                                        <input type='text' className='form-control' id='firstName' {...form.register('firstName')} />
                                    </div>
                                    <div className='col'>
                                        <label htmlFor='surname' className='form-label'>Soyadı</label>
                                        <input type='text' className='form-control' id='lastName' {...form.register('lastName')} />
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='username' className='form-label'>Kullanıcı Adı</label>
                                    <input type='text' className='form-control' id='username' {...form.register('username')} />
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='phone' className='form-label'>Telefon</label>
                                    <input type='tel' className='form-control' id='phoneNumber' {...form.register('phoneNumber')} />
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='password' className='form-label'>Şifre</label>
                                    <input type='password' className='form-control' id='password' {...form.register('password')} />
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='company' className='form-label'>Şirket</label>
                                    <select className='form-select' id='company' {...form.register('company')}>
                                        <option value="100">Şirket Seçin</option>
                                        {
                                            companies?.map((company) => (
                                                <option key={company.id} value={company.id}>{company.name}</option>
                                            ))
                                        }
                                    </select>
                                </div>

                                <div className='mb-3'>
                                    <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Kaydet</button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateUser